export function generateFractionalGradeTable() {
    const vGrades = [
        { grade: "VB-", top: 2, lineHeight: 66 },
        { grade: "VB", top: 68, lineHeight: 68 },
        { grade: "VB+", top: 136, lineHeight: 66 },
        { grade: "V0-", top: 202, lineHeight: 66 },
        { grade: "V0", top: 268, lineHeight: 68 },
        { grade: "V0+", top: 336, lineHeight: 66 },
        { grade: "V1", top: 402, lineHeight: 50 },
        { grade: "V2", top: 452, lineHeight: 50 },
        { grade: "V3", top: 502, lineHeight: 50 },
        { grade: "V4", top: 552, lineHeight: 50 },
        { grade: "V5", top: 602, lineHeight: 34 },
        { grade: "V6", top: 636, lineHeight: 32 },
        { grade: "V7", top: 668, lineHeight: 34 },
        { grade: "V8", top: 702, lineHeight: 34 },
        { grade: "V9", top: 736, lineHeight: 32 },
        { grade: "V10", top: 768, lineHeight: 34 },
        { grade: "V11", top: 802, lineHeight: 34 },
        { grade: "V12", top: 836, lineHeight: 32 },
        { grade: "V13", top: 868, lineHeight: 34 },
        { grade: "V14", top: 902, lineHeight: 34 },
        { grade: "V15", top: 936, lineHeight: 34 },
        { grade: "V16", top: 970, lineHeight: 32 },
        { grade: "V17", top: 1002, lineHeight: 34 },
    ];

    const fontGrades = [
        { grade: "1A", top: 2, lineHeight: 12 },
        { grade: "1A+", top: 14, lineHeight: 10 },
        { grade: "1B", top: 24, lineHeight: 12 },
        { grade: "1B+", top: 36, lineHeight: 10 },
        { grade: "1C", top: 46, lineHeight: 12 },
        { grade: "1C+", top: 58, lineHeight: 10 },
        { grade: "2A", top: 68, lineHeight: 12 },
        { grade: "2A+", top: 80, lineHeight: 10 },
        { grade: "2B", top: 90, lineHeight: 12 },
        { grade: "2B+", top: 102, lineHeight: 12 },
        { grade: "2C", top: 114, lineHeight: 10 },
        { grade: "2C+", top: 124, lineHeight: 12 },
        { grade: "3A", top: 136, lineHeight: 10 },
        { grade: "3A+", top: 146, lineHeight: 12 },
        { grade: "3B", top: 158, lineHeight: 10 },
        { grade: "3B+", top: 168, lineHeight: 12 },
        { grade: "3C", top: 180, lineHeight: 10 },
        { grade: "3C+", top: 190, lineHeight: 12 },
        { grade: "4A", top: 202, lineHeight: 34 },
        { grade: "4A+", top: 236, lineHeight: 32 },
        { grade: "4B", top: 268, lineHeight: 34 },
        { grade: "4B+", top: 302, lineHeight: 34 },
        { grade: "4C", top: 336, lineHeight: 32 },
        { grade: "4C+", top: 368, lineHeight: 34 },
        { grade: "5A", top: 402, lineHeight: 20 },
        { grade: "5A+", top: 422, lineHeight: 20 },
        { grade: "5B", top: 442, lineHeight: 20 },
        { grade: "5B+", top: 462, lineHeight: 20 },
        { grade: "5C", top: 482, lineHeight: 20 },
        { grade: "5C+", top: 502, lineHeight: 20 },
        { grade: "6A", top: 522, lineHeight: 20 },
        { grade: "6A+", top: 542, lineHeight: 20 },
        { grade: "6B", top: 562, lineHeight: 20 },
        { grade: "6B+", top: 582, lineHeight: 20 },
        { grade: "6C", top: 602, lineHeight: 26 },
        { grade: "6C+", top: 628, lineHeight: 24 },
        { grade: "7A", top: 652, lineHeight: 26 },
        { grade: "7A+", top: 678, lineHeight: 24 },
        { grade: "7B", top: 702, lineHeight: 26 },
        { grade: "7B+", top: 728, lineHeight: 24 },
        { grade: "7C", top: 752, lineHeight: 26 },
        { grade: "7C+", top: 778, lineHeight: 24 },
        { grade: "8A", top: 802, lineHeight: 34 },
        { grade: "8A+", top: 836, lineHeight: 32 },
        { grade: "8B", top: 868, lineHeight: 34 },
        { grade: "8B+", top: 902, lineHeight: 34 },
        { grade: "8C", top: 936, lineHeight: 34 },
        { grade: "8C+", top: 970, lineHeight: 32 },
        { grade: "9A", top: 1002, lineHeight: 34 },
    ];

    // console.log('Font grade ranges for 6A+, 6B, 6B+:',
    //     fontGrades.filter(g => ['6A+', '6B', '6B+'].includes(g.grade))
    //         .map(g => ({
    //             grade: g.grade,
    //             range: `${g.top} to ${g.top + g.lineHeight - 1}`
    //         }))
    // );

    const fractionalGradeTable = [];

    for (let i = 1; i <= 1100; i++) {
        const vGrade = vGrades.find(g => i >= g.top && i < g.top + g.lineHeight)?.grade || null;
        const fontGrade = fontGrades.find(g => i >= g.top && i < g.top + g.lineHeight)?.grade || null;
        
        // Log overlapping ranges for our grades of interest
        // if (['6A+', '6B', '6B+'].includes(fontGrade)) {
        //     console.log(`Fractional grade ${i}: Font=${fontGrade}, V=${vGrade}`);
        // }

        fractionalGradeTable.push({ fractionalGrade: i, vGrade: vGrade, fontGrade: fontGrade });
    }

    // Test specific grades
    // ['6A+', '6B', '6B+'].forEach(grade => {
    //     const matches = fractionalGradeTable.filter(row => row.fontGrade === grade);
    //     console.log(`\nAnalyzing ${grade}:`);
    //     console.log('Matching rows:', matches.map(m => ({
    //         fractional: m.fractionalGrade,
    //         vGrade: m.vGrade
    //     })));
    //
    //     const vGrades = matches
    //         .map(row => {
    //             const num = vGradeToNumber(row.vGrade);
    //             // console.log(`Converting ${row.vGrade} to ${num}`);
    //             return num;
    //         })
    //         .filter(num => num !== null);
    //
    //     const average = vGrades.reduce((sum, num) => sum + num, 0) / vGrades.length;
    //     console.log(`${grade} V-grades:`, vGrades);
    //     console.log(`${grade} average:`, average);
    // });

    return fractionalGradeTable;
}


export function vGradeToNumber(vGrade) {
    const vGradeMapping = {
        "VB-": -2,
        "VB": -1,
        "VB+": -0.5,
        "V0-": -0.25,
        "V0": 0,
        "V0+": 0.5,
        "V1": 1,
        "V2": 2,
        "V3": 3,
        "V4": 4,
        "V5": 5,
        "V6": 6,
        "V7": 7,
        "V8": 8,
        "V9": 9,
        "V10": 10,
        "V11": 11,
        "V12": 12,
        "V13": 13,
        "V14": 14,
        "V15": 15,
        "V16": 16,
        "V17": 17
    };
    const result = vGradeMapping[vGrade];
    return result;
}

// We should also update formatVGradeDecimal to handle negative numbers correctly
export const formatVGradeDecimal = (decimal) => {
    if (decimal === null || decimal === undefined) return '';
    
    if (decimal < -1.5) return 'VB-';
    if (decimal < -0.75) return 'VB';
    if (decimal < -0.375) return 'VB+';
    if (decimal < -0.125) return 'V0-';
    if (decimal < 0.25) return 'V0';
    if (decimal < 0.75) return 'V0+';
    
    // For V1 and above
    const wholeNumber = Math.floor(decimal);
    const fraction = decimal - wholeNumber;
    
    if (fraction < 0.25) return `V${wholeNumber}`;
    if (fraction < 0.75) return `V${wholeNumber}/V${wholeNumber + 1}`;
    return `V${wholeNumber + 1}`;
};

export function findAverageVGrade(fontGrade, fractionalGradeTable) {
    // Handle special cases for numeric-only plus grades (4+, 5+)
    if (/^[0-9]\+$/.test(fontGrade)) {
        const num = fontGrade.slice(0, -1);
        // For grades like 4+, search for both 4B and 4B+
        const searchGrades = [`${num}B`, `${num}B+`];
        const matchingRows = fractionalGradeTable.filter(row => 
            searchGrades.includes(row.fontGrade)
        );

        const vGrades = matchingRows
            .map(row => vGradeToNumber(row.vGrade))
            .filter(num => num !== null);

        if (vGrades.length === 0) return null;

        return vGrades.reduce((sum, grade) => sum + grade, 0) / vGrades.length;
    }
    
    // Normal processing for all other grades (6A+, 7B+, etc.)
    const matchingRows = fractionalGradeTable.filter(row => 
        row.fontGrade === fontGrade
    );

    const vGrades = matchingRows
        .map(row => vGradeToNumber(row.vGrade))
        .filter(num => num !== null);

    if (vGrades.length === 0) return null;

    return vGrades.reduce((sum, grade) => sum + grade, 0) / vGrades.length;
}